// shared css require needs to come first so component css can override shared css without needing !important
import ReactDOM from 'react-dom/client';
import { lazy } from 'react';
import { startBugsnag } from 'utils/bugsnag';
import OriginalLanguageButton from '../components/shared/OriginalLanguageButton';
import WaypointPopup from '../components/shared/MapPopups/WaypointPopup';
import PhotoPopup from '../components/shared/MapPopups/PhotoPopup';
import TrailHoverCard from '../components/cards/TrailHoverCard';
import ActivityHoverCard from '../components/cards/ActivityHoverCard';
import GlobalActions from '../components/GlobalActions';
import withSuspense from '../hocs/withSuspense';

require('@alltrails/maps/sharedCss.css');
require('@alltrails/shared/sharedCss.css');

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUJS = require('react_ujs');

const MapWidget = lazy(() => import('../application/javascripts/react_components/maps/MapWidget'));

startBugsnag();

const context = {
  MapWidget: withSuspense(MapWidget, 'MapWidget'),
  OriginalLanguageButton,
  WaypointPopup,
  PhotoPopup,
  TrailHoverCard,
  ActivityHoverCard,
  GlobalActions
};
ReactRailsUJS.getConstructor = className => context[className];

if (typeof window !== 'undefined') {
  const rootElement = document.getElementById('map-widget-root');
  if (rootElement && window.MAP_WIDGET_PROPS) {
    ReactDOM.hydrateRoot(rootElement, <MapWidget {...window.MAP_WIDGET_PROPS} />);
  }
}
